export const MAIL_CHANNEL = 'MAIL'
export const TEXT_CHANNEL = 'TEXT'
export const VOICE_CHANNEL = 'VOICE'
